// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.validation_modal {\n    width: 100%;\n}\n.validation_form {\n    width: 100%;\n    border-radius: 20px;\n    border: 1px solid black;\n    border-collapse: separate;\n    border-spacing: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    margin-top: 10px;\n}\n.row_padding {\n    margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
